module.exports = __webpack_public_path__ + "img/pillars_of_creation.734cb4a2.jpg";